import { Directive } from '@angular/core';

@Directive({
  selector: '[nttAvatarContent]',
})
export class NttAvatarContent {}
